import { lazyLoad } from 'utils/loadable';

export const PaymentFailure = lazyLoad(
  () => import('./index'),
  module => module.PaymentFailure,
);